export const oktaConstants = {
  scheme: 'okta',
  displayName: 'Okta'
};